/* eslint import/no-anonymous-default-export: [2, {"allowObject": true}] */
export default {
  title: "light",

  colors: {
    primary: "#387780",
    secundary: "#757780",
    tertiary: "#cecece",
    background: "#93bab4",
    text: "#333",
    textbutton: "#fff",
    black: "#000",
  },
};
